module.exports = __webpack_public_path__ + "static/media/realbooks_front.df547edc.png";